import { Box, SimpleGrid, useColorModeValue as mode } from '@chakra-ui/react'
import { IconUser } from '@tabler/icons';
import React, {useRef} from 'react'
import { items } from './NavItemIcon'
import { CartCount } from './CartCount'
import { NavAction } from './NavAction'
import { useAppState } from '../context'
import useAuth from '../hooks/useAuth'

export const MobileBottomNav = () => {

  const { loggedIn, user } = useAuth();
  const { cart } = useAppState()
    
  return (
    <Box
      bg={mode('white', 'gray.800')}
      pos="fixed"
      width="full"
      bottom="env(safe-area-inset-bottom)"
      borderTopWidth="1px"
      zIndex="99"
      display={{ lg: 'none' }}
    >
      <SimpleGrid columns={2} padding="2">
        {/* hide cart if user is not logged in  */}
         {!loggedIn ? (
            <></>
            ) : (
            <NavAction.Mobile {...items.cart} isActive>
              <CartCount right="-2">{cart?.contents.itemCount || 0}</CartCount>
            </NavAction.Mobile>
        )}
        {/* show different link based on log in */}
         {!loggedIn ?
            (<NavAction.Mobile {...items.user} />) :
            (<NavAction.Mobile label={user?.firstName == null ? "Customer" : user.firstName} href="/acc-settings" icon={IconUser} />)}
      </SimpleGrid>
    </Box>
  )
}

export default MobileBottomNav